export default __webpack_public_path__ + "static/media/patterns-no-4.17da23f3.mid";